module.exports = __webpack_public_path__ + "static/assets/6dc179cd062bcdc2a69de5c049994fe2.png";